export default {
  disclaimer: {
    summary:
      'Ten en cuenta que es tu responsabilidad confirmar que la moneda y los impuestos sean correctos para la jurisdicción aplicable.',
    extra:
      'Incluimos esta información solo para tu comodidad y no asumimos ninguna responsabilidad por la exactitud de la moneda y/o los impuestos ni por el pago de dichos impuestos como parte de nuestros productos. La información aquí contenida sobre moneda e impuestos es únicamente de carácter informativo.',
    show_more: 'Mostrar más',
    show_less: 'Mostrar menos',
  },
  partner_note:
    'Estos son tus valores predeterminados a nivel de socio. Los restaurantes de tu cuenta heredan estos valores automáticamente salvo que anulen una categoría individualmente.',
  section_title: 'Tasas impositivas para los artículos del menú',
  new_category_placeholder: 'Nueva categoría',
  form: {
    name: {
      label: 'Categoría fiscal',
    },
    default_tax_rate: {
      label: 'Tasa predeterminada',
      tooltip: 'Se usa como valor de reserva cuando una tasa específica por método de pedido se deja vacía.',
    },
    pickup_tax_rate: {
      label: 'Recogida',
    },
    delivery_tax_rate: {
      label: 'Entrega',
    },
    dine_in_tax_rate: {
      label: 'En el restaurante',
    },
    on_site_tax_rate: {
      label: 'Pedidos en mesa',
    },
    show_zero_tax_in_summary: {
      label: 'Mostrar 0% de impuesto en el resumen del pedido',
    },
  },
  buttons: {
    add_category: 'Agregar nueva categoría fiscal',
    cancel: 'Cancelar',
    save: 'Guardar',
    confirm: 'Eliminar',
    delete: 'Eliminar categoría',
    reset: 'Restablecer al heredado',
  },
  delete_confirm: {
    title: '¿Eliminar esta categoría fiscal?',
    description: 'Esta acción no se puede deshacer.',
  },
  scope_labels: {
    region: 'Toda la región',
    partner: 'Todo el partner',
    restaurant: 'Todo el restaurante',
  },
  confirm_modal: {
    title: {
      fork: '¿Convertirla en una categoría propia de este restaurante?',
      owned: '¿Aplicar las nuevas tarifas?',
      reset: '¿Volver a la categoría heredada?',
    },
    affected_one: '{{count}} producto o categoría está actualmente vinculado y se le cobrarán las nuevas tarifas.',
    affected_other:
      '{{count}} productos y categorías están actualmente vinculados y se les cobrarán las nuevas tarifas.',
    affected_settings_one:
      '{{count}} producto o categoría está actualmente vinculado y usará la configuración actualizada.',
    affected_settings_other:
      '{{count}} productos y categorías están actualmente vinculados y usarán la configuración actualizada.',
    restaurants_one: 'Es {{count}} restaurante.',
    restaurants_other: 'Son {{count}} restaurantes.',
    acknowledge:
      'Entiendo que confirmar esto cambia la categoría de impuestos de todos los productos actualmente vinculados a esta categoría',
    impact_error: 'Error al comprobar qué productos se verían afectados',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
  },
  toasts: {
    load_error: 'No se pudieron cargar las categorías fiscales.',
    failed_to_save_changes: 'Error al guardar los cambios',
    changes_got_saved: 'Los cambios se guardaron',
    delete_error: 'No se pudo eliminar esta categoría fiscal.',
    category_deleted: 'Categoría fiscal eliminada',
    category_reset: 'Categoría de impuestos restablecida a la heredada',
    reset_error: 'No se pudo restablecer esta categoría de impuestos.',
    impact_error: 'Error al comprobar qué productos se verían afectados',
    impact_changed_one: 'El número de productos afectados cambió a {{count}}. Revisa y confirma de nuevo.',
    impact_changed_other: 'El número de productos afectados cambió a {{count}}. Revisa y confirma de nuevo.',
  },
};
